module.exports = __webpack_public_path__ + "img/blog-29.764851d8.jpg";